import { createFeatureSelector, createSelector } from '@ngrx/store';
import { authFeatureKey, IAuthState } from './auth-state.reducer';

export const selectAuthState = createFeatureSelector<IAuthState>(authFeatureKey);
export const selectHipUser = createSelector(
  selectAuthState,
  (authState) => authState.currentHipUser
);
